import { ApplicationGroup } from '../../../../insights/types/InsightsTypes';
import { MyApp } from '../../../types/myAppTypes';
import { DocumentNode } from 'graphql/index';
import {
  BaseApplicationProperty,
  MutationStatus,
  UpdateApplicationMutationResult,
  UpdateApplicationsQuery,
} from './BaseApplicationProperty';

/**
 * Represents a group of applications with properties and methods for updating and displaying application group information.
 */
export class AppGroup implements BaseApplicationProperty {
  field: string;
  value?: ApplicationGroup;
  label: string = 'App Group';

  constructor(field: string) {
    this.field = field;
  }

  /**
   * Sets the value of the application group.
   * @param value - The application group to set.
   */
  set(value: ApplicationGroup) {
    this.value = value;
  }

  /**
   * Returns the mutation input for the application group.
   */
  propertyMutationInput() {
    return {
      appGroup: this.value?.applicationId,
    };
  }
  /**
   * Returns the current display value of the application group.
   * @param app - The application to get the display value from.
   * @returns The current display value of the application group.
   */
  getCurrentDisplayValue(app: MyApp): string {
    return `${app.appGroup}`;
  }

  /**
   * Returns the new display value of the application group.
   * @returns The new display value of the application group.
   */
  getNewDisplayValue(): string {
    return `${this.value?.name}`;
  }
  /**
   * Returns the mutation query for updating applications.
   * @returns The mutation query document node.
   */
  mutationQuery(): DocumentNode {
    return UpdateApplicationsQuery;
  }
  /**
   * Returns the mutation result for updating applications.
   * @param data - The result data from the update application mutation.
   * @returns An array of mutation statuses.
   */
  getMutationResult(data: UpdateApplicationMutationResult): MutationStatus[] {
    return data?.resources?.application?.updateApplications ?? [];
  }
}
